export default (params) => ({
  trigger: {
    name: 'recommended_accessories.click_reviews_of_shown_product',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'recommended_accessories',
          'recommended_accessories_alternative_overlay',
        ],
      },
    },
    event: {
      name: 'read_reviews',
    },
  },
});
